import React, { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import Story from "../components/Story"
import "./SingleProject.css"

const BASE_URL = process.env.REACT_APP_API_URL

export default function SingleProject() {


    const { id } = useParams()
    const [header, setHeader] = useState(null)
    const [content, setContent] = useState(null)
    const [images, setImages] = useState([])
    const [story, setStories] = useState([])


    useEffect(() => {
        fetchStory()
    },[])

    const fetchStory = async () => {
        try {

            const response = await fetch(BASE_URL + "/stories/getOneStory/" + id)
            const data = await response.json()

            setHeader(data[0].header)
            setContent(data[0].content)
            const imageUrls = data.map(row => row.imageurl);
            setImages(imageUrls)
            console.log("0", images, imageUrls)

        } catch (error) {
            console.log(error)
        }
    }

    const handleStoryUpdated = async () => {
        const updatedData = await fetchStory(id)
      }

    return (
        <div>
            {story ? (
                <div key={story.id}>
                    <Story
                        header={header}
                        content={content}
                        images={images}
                        onUpdate={handleStoryUpdated}
                    />
                </div>
            ) : (
                <p>Loading story...</p>
            )}
        </div>
    )
}
